import { type Dictionary } from '@ngrx/entity';

import { type GlobalQueryState } from '@blaze-shared/elements-domain';

export function getGlobalQueryForElement(
  elementId: string,
  globalQuery: Dictionary<GlobalQueryState> | undefined,
): GlobalQueryState | undefined {
  if (!globalQuery) {
    return;
  }
  return Object.values(globalQuery).find((gq) => gq?.elementId === elementId);
}
